/**
 * hhm-stats: GSAP scroll-triggered header + staggered stat cards; counter animates when in view.
 */
(function () {
	'use strict';

	function easeOutQuart(t) {
		return 1 - Math.pow(1 - t, 4);
	}

	function runCounter(el) {
		const target = parseFloat(el.getAttribute('data-target'), 10);
		const suffix = el.getAttribute('data-suffix') || '';
		const duration = parseInt(el.getAttribute('data-duration'), 10) || 1500;
		const start = 0;
		const startTime = performance.now();

		function update(now) {
			const elapsed = now - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const eased = easeOutQuart(progress);
			const current = start + (target - start) * eased;
			const isInteger = target === Math.floor(target);
			el.textContent = isInteger ? Math.round(current) + suffix : current.toFixed(1) + suffix;

			if (progress < 1) {
				requestAnimationFrame(update);
			} else {
				el.textContent = (isInteger ? Math.round(target) : target) + suffix;
				el.setAttribute('data-counted', '1');
			}
		}

		requestAnimationFrame(update);
	}

	function initCounters() {
		const section = document.querySelector('.hhm-stats-section');
		if (!section) return;

		const counters = section.querySelectorAll('.hhm-stat-counter:not([data-counted="1"])');
		if (!counters.length) return;

		const observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;
					const el = entry.target;
					if (el.getAttribute('data-counted') === '1') return;
					runCounter(el);
					observer.unobserve(el);
				});
			},
			{ rootMargin: '0px 0px -50px 0px', threshold: 0.1 }
		);

		counters.forEach(function (el) {
			observer.observe(el);
		});
	}

	function initGSAP() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
		gsap.registerPlugin(ScrollTrigger);

		const section = document.querySelector('.hhm-stats-section');
		if (!section) return;

		const easeSnappy = 'power2.out';

		// Header: badge, title, description — staggered fade-up
		const header = section.querySelector('.hhm-stats__header');
		if (header) {
			const badge = header.querySelector('.hhm-stats__badge');
			const title = header.querySelector('.hhm-stats__title');
			const desc = header.querySelector('.hhm-stats__desc');
			const headerEls = [badge, title, desc].filter(Boolean);
			if (headerEls.length) {
				gsap.set(headerEls, { opacity: 0, y: 28 });
				gsap.to(headerEls, {
					opacity: 1,
					y: 0,
					duration: 0.65,
					stagger: 0.1,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: header,
						start: 'top 88%',
						toggleActions: 'play none none none',
					},
				});
			}
		}

		// Stat cards: staggered fade-up
		const grid = section.querySelector('.hhm-stats__grid');
		const items = section.querySelectorAll('.hhm-stat-item');
		if (grid && items.length) {
			gsap.set(items, { opacity: 0, y: 32 });
			gsap.to(items, {
				opacity: 1,
				y: 0,
				duration: 0.6,
				stagger: 0.08,
				ease: easeSnappy,
				scrollTrigger: {
					trigger: grid,
					start: 'top 85%',
					toggleActions: 'play none none none',
				},
			});
		}
	}

	function init() {
		initCounters();
		initGSAP();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
